import React, { useState, useEffect } from "react";
import { useData } from "../util/dataProvider";
import { Link } from "react-router-dom";

export default function Unternehmen({ field }) {
    const { filteredUnternehmen } = useData();
    const [filter, setFilter] = useState("all");

    useEffect(() => {
        setFilter(field);
    }, [field]);

    const CompanyList = ({ category, headline }) => {
        const companies = filteredUnternehmen.filter(
            (un) => un.category == category
        );
        if (companies && companies.length === 0) {
            return "";
        }

        return (
            <div className='cat'>
                <h3>{headline}</h3>
                <div className='list'>
                    {companies &&
                        companies.map((unternehmen, idx) => {
                            return (
                                <Link
                                    to={`/company/${unternehmen.id}`}
                                    key={idx}
                                    className='list-item'>
                                    <div>
                                        <div className='head'>
                                            {unternehmen.name}
                                        </div>
                                        <div className='sub'>
                                            {unternehmen.fields.join(", ")}
                                        </div>
                                    </div>
                                    <div className='right'>
                                        <div className='button'>Zum Profil</div>
                                    </div>
                                </Link>
                            );
                        })}
                </div>
            </div>
        );
    };
    return (
        <div className='home-content'>
            <div className='bm-header'>
                <div className='sub'>Unternehmen im Kompetenzverbund</div>
                <h1 className='bm-main'>Unsere Innovator*innen</h1>
                {(filter === "all" || filter === "forschung") && (
                    <CompanyList
                        category='forschung'
                        headline='Forschung und Entwicklung'
                    />
                )}
                {(filter === "all" || filter === "startup") && (
                    <CompanyList category='startup' headline='Start-Up' />
                )}
                {(filter === "all" || filter === "unternehmen") && (
                    <CompanyList
                        category='unternehmen'
                        headline='Unternehmen'
                    />
                )}
            </div>
        </div>
    );
}
